<template>
<div>
  <div id="wrapper" :class="$i18n.locale=='zh'?'Lato-Light':'Lato-Light'" v-if="activeIndex != '/staffLogin'">
    <div class="loading-overlay" style="display: none;">
      <div class="loading-logo in">
        <img :src="logImg" alt="logo"/>
      </div>
    </div>
    
    <el-container>
      <el-header id="header">
        <div class="inner-wrapper">
          <div class="container">
            <el-row type="flex" class="row-bg" style="height: 43px">
              <el-col :xs="8" :sm="6" :md="4" :lg="3" class="logo">
                <a href="javascript:void(0);" title="kerry logistics" @click="toHome">
                  <img :src="logImg" style="height: 100%;width: auto">
                </a>
              </el-col>
              <el-col :span="20" :class="$i18n.locale=='zh'?'pcmenu':'pcmenu en-pcmenu'" style="float:right">
                  <el-menu
                    :default-active="activeIndex" 
                    :unique-opened="true"
                    mode="horizontal"
                    text-color="#707070"
                    active-text-color="#ed6d00"
                    :router="true"
                    @select="handleSelect"
                    class="menu">
                    <!-- <el-submenu :index="item.id" v-for="(item, index) in $t('menu')" :key="item.id">
                      <template slot="title">{{item.name}}</template>
                      <el-menu-item :index="subItem.id" v-for="subItem in item.subName" :key="subItem.id">
                        <a>{{subItem.name}}</a>
                      </el-menu-item>
                    </el-submenu> -->
                    <el-menu-item :index="menuData[0].index">{{$t('menu[0].name')}}</el-menu-item>
                    <el-submenu :index="menuData[1].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[1].subMenu[0].index)">{{$t('menu[1].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[0].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" v-if="$i18n.locale=='zh'" :index="menuData[1].subMenu[1].index" style="width:336px;padding-left:22px;padding-right:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" v-if="$i18n.locale=='en'" :index="menuData[1].subMenu[1].index" style="width:336px;padding-left:22px;padding-right:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[1].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[2].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[3].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[4].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[4].name')}}</el-menu-item>
                      <!-- <el-menu-item :index="menuData[1].subMenu[5].index">{{$t('menu[1].subName[5].name')}}</el-menu-item> -->
                    </el-submenu>
                    <el-submenu :index="menuData[2].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[2].subMenu[0].index)">{{$t('menu[2].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[4].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[5].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[5].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[6].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[6].name')}}</el-menu-item>
                      <!-- <el-menu-item :index="menuData[2].subMenu[7].index">{{$t('menu[2].subName[7].name')}}</el-menu-item> -->
                    </el-submenu>
                    <el-submenu :index="menuData[3].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[3].subMenu[0].index)">{{$t('menu[3].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[3].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[3].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[3].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;pointer-events: none;">{{$t('menu[3].subName[3].name')}}</el-menu-item>
                    </el-submenu>
                    <!-- <el-menu-item :index="menuData[4].index">{{$t('menu[4].name')}}</el-menu-item> -->
                    <el-submenu v-if="$i18n.locale=='zh'" :index="menuData[4].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[4].subMenu[0].index)">{{$t('menu[4].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[3].name')}}</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="$i18n.locale=='en'" :index="menuData[4].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[4].subMenu[0].index)">{{$t('menu[4].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[0].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[1].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[2].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[3].name')}}</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="$i18n.locale=='zh'" :index="menuData[5].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[5].subMenu[0].index)">{{$t('menu[5].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[4].name')}}</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="$i18n.locale=='en'" :index="menuData[5].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[5].subMenu[0].index)">{{$t('menu[5].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[4].name')}}</el-menu-item>
                    </el-submenu>
                    <!-- <el-menu-item :index="menuData[4].index">{{$t('menu[4].name')}}</el-menu-item> -->
                    <!-- <el-menu-item :index="menuData[5].index">{{$t('menu[5].name')}}</el-menu-item> -->
                    <el-submenu :index="menuData[6].index">
                      <template slot="title">
                        <span style="display:block;line-height:60px;" @click.stop="goToDetail(menuData[6].subMenu[0].index)">{{$t('menu[6].name')}}</span>
                      </template>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[3].name')}}</el-menu-item>
                      <!-- <el-menu-item class="menuItem" :index="menuData[6].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[4].name')}}</el-menu-item> -->
                    </el-submenu>
                    <!-- <el-submenu :index="menuData[7].index"> -->
                      <!-- <template slot="title">{{$t('menu[7].name')}}</template> -->
                      <!-- <el-menu-item class="menuItem" :index="menuData[8].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[7].subName[0].name')}}</el-menu-item> -->
                      <!-- <el-menu-item class="menuItem" :index="menuData[8].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[7].subName[1].name')}}</el-menu-item> -->
                      <!-- <el-menu-item class="menuItem" :index="menuData[8].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[7].subName[2].name')}}</el-menu-item> -->
                    <!-- </el-submenu> -->
                    <!-- <el-menu-item :index="menuData[7].index">{{$t('menu[7].name')}}</el-menu-item> -->
                    <!-- <el-menu-item :index="menuData[8].index">{{$t('menu[8].name')}}</el-menu-item> -->
                    <!-- <el-menu-item :index="menuData[8].index">{{$t('menu[8].name')}}</el-menu-item> -->
                    <!-- <el-submenu :index="menuData[8].index">
                      <template slot="title">{{$t('menu[8].name')}}</template>
                      <div class="login-box">
                        <div class="login-row"><el-input v-model="account" :placeholder="$t('login.placeholder1')"></el-input></div>
                        <div class="login-row"><el-input v-model="password" show-password :placeholder="$t('login.placeholder2')"></el-input></div>
                        <div class="login-row"><el-button style="width:100%;background:#ED6D00;color:#ffffff;">{{$t('login.login')}}</el-button></div>
                      </div>
                    </el-submenu> -->
                  </el-menu>
              </el-col>
              <el-col :span="20" class="phonemenu">
                <el-popover
                  ref="popover"
                  placement="bottom"
                  :width="phoneWidth"
                  trigger="click"
                >
                  <el-menu
                    :default-active="activeIndex" 
                    :unique-opened="true"
                    mode="vertical"
                    text-color="#707070"
                    active-text-color="#ed6d00"
                    :router="true"
                    @select="handleSelect"
                    style="border-right:0px;"
                    class="menu">
                    <!-- <el-submenu :index="item.id" v-for="(item, index) in $t('menu')" :key="item.id">
                      <template slot="title">{{item.name}}</template>
                      <el-menu-item :index="subItem.id" v-for="subItem in item.subName" :key="subItem.id">
                        <a>{{subItem.name}}</a>
                      </el-menu-item>
                    </el-submenu> -->
                    <el-menu-item :index="menuData[0].index" style="padding-left:10px;">{{$t('menu[0].name')}}</el-menu-item>
                    <el-submenu :index="menuData[1].index">
                      <template slot="title">{{$t('menu[1].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[0].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[1].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[2].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[3].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[1].subMenu[4].index" style="width:336px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[1].subName[4].name')}}</el-menu-item>
                      <!-- <el-menu-item :index="menuData[1].subMenu[5].index">{{$t('menu[1].subName[5].name')}}</el-menu-item> -->
                    </el-submenu>
                    <el-submenu :index="menuData[2].index">
                      <template slot="title">{{$t('menu[2].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[4].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[5].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[5].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[2].subMenu[6].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[2].subName[6].name')}}</el-menu-item>
                      <!-- <el-menu-item :index="menuData[2].subMenu[7].index">{{$t('menu[2].subName[7].name')}}</el-menu-item> -->
                    </el-submenu>
                    <el-submenu :index="menuData[3].index">
                      <template slot="title">{{$t('menu[3].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[3].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[3].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[3].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[3].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;pointer-events: none;">{{$t('menu[3].subName[3].name')}}</el-menu-item>
                    </el-submenu>
                    <!-- <el-menu-item :index="menuData[4].index">{{$t('menu[4].name')}}</el-menu-item> -->
                    <el-submenu v-if="$i18n.locale=='zh'" :index="menuData[4].index">
                      <template slot="title">{{$t('menu[4].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[4].subName[3].name')}}</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="$i18n.locale=='en'" :index="menuData[4].index">
                      <template slot="title">{{$t('menu[4].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[0].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;white-space: break-spaces;">{{$t('menu[4].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[1].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;white-space: break-spaces;">{{$t('menu[4].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[2].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;white-space: break-spaces;">{{$t('menu[4].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[4].subMenu[3].index" style="width:326px;padding-left:22px;height:62px;line-height:31px;white-space: break-spaces;">{{$t('menu[4].subName[3].name')}}</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="$i18n.locale=='zh'" :index="menuData[5].index">
                      <template slot="title">{{$t('menu[5].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[5].subName[4].name')}}</el-menu-item>
                    </el-submenu>
                    <el-submenu v-if="$i18n.locale=='en'" :index="menuData[5].index">
                      <template slot="title">{{$t('menu[5].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:31px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[3].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[5].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;word-break: break-word;white-space: break-spaces;">{{$t('menu[5].subName[4].name')}}</el-menu-item>
                    </el-submenu>
                    <!-- <el-menu-item :index="menuData[4].index">{{$t('menu[4].name')}}</el-menu-item> -->
                    <!-- <el-menu-item :index="menuData[5].index">{{$t('menu[5].name')}}</el-menu-item> -->
                    <el-submenu :index="menuData[6].index">
                      <template slot="title">{{$t('menu[6].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[1].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[2].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[6].subMenu[3].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[3].name')}}</el-menu-item>
                      <!-- <el-menu-item class="menuItem" :index="menuData[6].subMenu[4].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[6].subName[4].name')}}</el-menu-item> -->
                    </el-submenu>
                    <!-- <el-submenu :index="menuData[7].index">
                      <template slot="title">{{$t('menu[7].name')}}</template>
                      <el-menu-item class="menuItem" :index="menuData[8].subMenu[0].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[7].subName[0].name')}}</el-menu-item>
                      <el-menu-item class="menuItem" :index="menuData[8].subMenu[1].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[7].subName[1].name')}}</el-menu-item> -->
                      <!-- <el-menu-item class="menuItem" :index="menuData[8].subMenu[2].index" style="width:316px;padding-left:22px;height:62px;line-height:62px;">{{$t('menu[7].subName[2].name')}}</el-menu-item> -->
                    <!-- </el-submenu> -->
                    <!-- <el-menu-item :index="menuData[7].index">{{$t('menu[7].name')}}</el-menu-item> -->
                    <!-- <el-menu-item :index="menuData[8].index">{{$t('menu[8].name')}}</el-menu-item> -->
                    <el-menu-item :index="menuData[8].index" style="padding-left:10px;">{{$t('menu[8].name')}}</el-menu-item>
                    <!-- <el-submenu :index="menuData[8].index">
                      <template slot="title">{{$t('menu[8].name')}}</template>
                      <div class="login-box">
                        <div class="login-row"><el-input v-model="account" :placeholder="$t('login.placeholder1')"></el-input></div>
                        <div class="login-row"><el-input v-model="password" show-password :placeholder="$t('login.placeholder2')"></el-input></div>
                        <div class="login-row"><el-button style="width:100%;background:#ED6D00;color:#ffffff;">{{$t('login.login')}}</el-button></div>
                      </div>
                    </el-submenu> -->
                  </el-menu>
                  <i slot="reference" class="el-icon-s-fold" style="color: #ED6D00;font-size: 28px;"></i>
                </el-popover>
              </el-col>
              <div class="field-lang icon-lang-trigger col" style="display: none;">
                <div class="icon-trigger">
                  <el-dropdown trigger="click" @command="selectLanguage" style="font-family:'Lato-Light'">
                    <span class="el-dropdown-link">
                      <img :src="locationImg">
                      <!-- 下拉菜单<i class="el-icon-arrow-down el-icon--right"></i> -->
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item :style="$i18n.locale=='zh'?'color:#ed6d00':''" command="zh">简</el-dropdown-item>
                      <!-- <el-dropdown-item :style="$i18n.locale=='en'?'color:#ed6d00;font-family:Lato':''" command="en">EN</el-dropdown-item> -->
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </el-row>
          </div>
        </div>
      </el-header>

      <el-main id="main">
        <keep-alive>
         <router-view></router-view>
        </keep-alive>
      </el-main>

      <el-footer id="footer">
        <div class="inner-wrapper">
          <div class="container">
            <el-row>
              <el-col :xs="24" :md="18">
                <div class="social">
                  <el-col>
                    <P>客服电话：400-092-8856</P>
                      <P></P>
                  </el-col>
                  <p>{{$t('footer.focus')}}</p>
                  <el-row class="social-icons">
                    <div class="icon">
                      <el-popover
                        placement="top-start"
                        width="80"
                        trigger="hover"
                        content="">
                        <!-- <div style="text-align: center;width:100px;"> -->
                          <img :src="require('./assets/images/erweima.jpg')" alt="WECAT" style="width:100%;">
                        <!-- </div> -->
                        <img slot="reference" :src="require('./assets/images/weixin.svg')" alt="WECAT" style="width:32px;height:32px;">
                      </el-popover>
                      <!-- <a href="javascript: void(0);" rel="noopener noreferrer" title="SINA">
                        <img :src="footer.img[1].img" alt="SINA">
                      </a> -->
                    </div>
                    <div class="icon">
                      <el-popover
                        placement="top-start"
                        width="80"
                        trigger="hover"
                        content="">
                        <!-- <div style="text-align: center;width:100px;"> -->
                          <img :src="require('./assets/images/erweima_weibo.png')" alt="SINA" style="width:100%;">
                        <!-- </div> -->
                        <img slot="reference" :src="require('./assets/images/weibo.svg')" alt="WECAT" style="width:32px;height:32px;">
                      </el-popover>
                      <!-- <a href="javascript: void(0);" rel="noopener noreferrer" title="SINA">
                        <img :src="footer.img[0].img" alt="SINA">
                      </a> -->
                    </div>
                  </el-row>
                </div>
              </el-col>
              <el-col :xs="24" :md="6">
                <div class="group-member">
                  <!-- <div class="vip-title">{{$t('footer.member')}}</div> -->
                  <a href="https://www.kln.com" target="_blank" rel="noopener noreferrer">
                    <img :src="footer.img[2].img" alt="member of KLN">
                  </a>
                  <!-- <a href="https://www.kln.com" target="_blank" rel="noopener noreferrer" style="margin:0 30px;">
                    <img :src="footer.img[3].img" alt="member of KLN">
                  </a> -->
                </div>
              </el-col>

            </el-row>
            <el-row class="footer-links">
              <el-col :xs="24" :sm="12" :md="14" class="links">
                <ul class="other-links">
                  <li class="link link-line-color">
                    <a href="javascript: void(0);">{{$t('footer.link5')}}</a>
                  </li>
                  <li class="link link-line-color">
                    <a href="https://www.kln.com" :title="$t('footer.link7')">{{$t('footer.link7')}}</a>
                  </li>
                  <!-- <li class="link link-line-color">
                    <a href="https://www.kerrylogistics.com/tc/" :title="$t('footer.link6')">{{$t('footer.link6')}}</a>
                  </li> -->
                  <li class="link link-line-color">
                    <a href="https://lanhai.kln.cn/" :title="$t('footer.link8')">{{$t('footer.link8')}}</a>
                  </li>
                  <!-- <li class="link link-line-color" @click="goToNet"> -->
                    <!-- <a href="javascript: void(0);" :title="$t('footer.link4')">{{$t('footer.link4')}}</a> -->
                  <!-- </li> -->
                </ul>
                <ul class="other-links">
                  <li class="link link-line-color">
                    <a href="javascript: void(0);" :title="$t('footer.link1')">{{$t('footer.link1')}}</a>
                  </li>
                  <li class="link link-line-color">
                    <a href="javascript: void(0);" :title="$t('footer.link2')">{{$t('footer.link2')}}</a>
                  </li>
                  <li class="link link-line-color">
                    <a href="javascript: void(0);" :style="$i18n.locale=='zh'?{'display':'inline-block','text-align':'left'}:''" :title="$t('footer.link3')">{{$t('footer.link3')}}</a>
                  </li>
                  <!-- <li class="link">
                    <a href="/https://klnportal.kerrylogistics.com" title="$t('footer.link4')">{{$t('footer.link4')}}</a>
                  </li> -->
                </ul>
              </el-col>
              <el-col :xs="24" :sm="12" :md="10" class="copyright">
                <div style="position:relative">
                  <img src="./assets/images/plice1.png" style="width:18px;position:absolute;top:3px;">
                  <span style="margin-left:20px"><a href="https://beian.miit.gov.cn/#/Integrated/index">京ICP备09057760号-5</a></span>
                </div>
                <div>© 2020 KLN IMS CHEMICAL LOGISTICS CO.,LTD ALL RIGHTS RESERVED.</div>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24" class="narrative">
                <div>KLN Chemical Logistics (Shanghai) Co., Ltd.<br>{{$t('footer.company')}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-footer>
    </el-container>

    <div class="mouse_anim" ref="_mouseAnim"></div>
  </div>
  <div :class="$i18n.locale=='zh'?'Lato-Light':'Lato-Light'" v-if="activeIndex == '/staffLogin'">
    <router-view></router-view>
  </div>
  </div>
</template>

<script>
import store from './store/index'
export default {
  name: "app",
    components: {
  },
  store,
  data() {
    return {
      phoneWidth: 400,
      // 当前页面id
      pageId: {},
      account: '',
      password: '',
      activeIndex: "/index",
      // 封面高度
      coverHeight: 1080,

      // 滚动条高度
      scrollTopHeight: 0,

      // 菜单
      menuData: [
        {
          id: 1,
          index: "/index"
        },{
          id: 2,
          index: "/services",
          subMenu: [
            {
              index: "/services/warehousing"
            },{
              index: "/services/diversifiedTransport"
            },{
              index: "/services/internationalFreight"
            },{
              index: "/services/valueAdded"
            },{
              index: "/services/supplyChain"
            },{
              index: "/services/moreServices"
            }
          ]
        },{
          id: 3,
          index: "/industries",
          subMenu: [
            {
              index: "/industries/appliedMaterials"
            },{
              index: "/industries/paintCoating"
            },{
              index: "/industries/lubricatingOil"
            },{
              index: "/industries/agrochemical"
            },{
              index: "/industries/electronicChemical"
            },{
              index: "/industries/newEnergy"
            },{
              index: "/industries/chemicalReagent"
            },{
              index: "/industries/moreIndustries"
            }
          ]
        },{
          id: 4,
          index: "/globalNet",
          subMenu: [
            {
              index: "/globalNet/eastChina"
            },{
              index: "/globalNet/northChina"
            },{
              index: "/globalNet/southwest"
            },{
              index: "/globalNet/southChina"
            }
          ]
        },{
          id: 5,
          index: "/technology",
          subMenu: [
            {
              index: "/technology/storageVisualization"
            },{
              index: "/technology/transportationVisualization"
            },{
              index: "/technology/independentlySoftware"
            },{
              index: "/technology/clientInterface"
            }
          ]
        },{
          id: 6,
          index: "/security",
          subMenu: [
            {
              index: "/security/integrated"
            },{
              index: "/security/institutional"
            },{
              index: "/security/responsibilityLanding"
            },{
              index: "/security/contingency"
            },{
              index: "/security/characteristicDisplay"
            }
          ]
        },{
          id: 7,
          index: "/about",
          subMenu: [
            {
              index: "/about/vision"
            },{
              index: "/about/glory"
            },{
              index: "/about/responsibility"
            },{
              index: "/about/contact"
            },{
              index: "/about/partners"
            }
          ]
        },{
          id: 8,
          index: "/contact/"
        },
        {
          id: 9,
          index: "/kportal"
        },
        // {
        //   id: 9,
        //   index: "/news",
        //   subMenu: [
        //     {
        //       index: "/news/groupNews"
        //     },
        //     {
        //       index: "/news/industryDynamics"
        //     },
        //     {
        //       index: "/news/mediaCoverage"
        //     }
        //   ]
        // },
        {
          id: 10,
          index: "/join"
        },{
          id: 11,
          index: "/login"
        }
      ],

      logImg: require("./assets/images/logo.svg"),
      locationImg: require("./assets/images/icon-lang.svg"),
      footer: {
        img: [
          {
            id: 1,
            img: require("./assets/images/weibo.svg")
          },{
            id: 2,
            img: require("./assets/images/weixin.svg")
          },{
            id: 3,
            img: require("./assets/images/logo-kln.png")
          },{
            id: 4,
            img: require("./assets/images/jklogo.png")
          }
        ]
      }
    };
  },
  props: {
    // coverHeightGlobal: String,
  },

  created() {
    this.activeIndex = this.$route.path
    // 菜单数据处理
    var menuLang = this.$i18n.t('menu');
    // localStorage.setItem('lang', value)
    if(localStorage.getItem('lang')){
      // this.$i18n.locale = 'zh'
    }else{
      localStorage.setItem('lang', 'zh')
    }
    // 在页面加载时读取sessionStorage里的状态信息
    if(sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      )
    }

    // 在页面刷新时将Vuex里的信息保存到sessionStorage里
    // beforeunload事件在页面刷新时先触发
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    })
  },

  mounted: function () {
    this.phoneWidth = document.body.clientWidth
    this.getStoreState();

    this.getShowApply();

    //创建元素
    const h = this.$createElement;
    
    // 默认首页
    // this.showPageIndex(this.menuData[0]);
    // this.showPageIndex(this.pageId);

    //阻止整个页面所有的右击事件
    document.oncontextmenu = function () {
      return false;
    };
    // this.mouseAnimate();

    window.addEventListener("scroll", this.getScrollTop);

    this.resize();
    window.addEventListener("resize", this.resize);

    // 监听浏览器返回事件
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.goBack, false)
    }
  },

  destroyed: function () {
    window.removeEventListener("scroll", this.getScrollTop);

    window.addEventListener("resize", this.resize);

    window.removeEventListener('popstate', this.goBack, false);
  },

  watch:{
    //监听路由变化
    $route(to,from){
        console.log(from.path);//从哪来
        console.log(to.path);//到哪去
        this.activeIndex = to.path
        this.$refs.popover.showPopper = false
    }
  },

  methods: {
    goToDetail(path) {
      this.$router.push({path: path})
    },
    toHome() {
      this.$router.push({path: '/index'})
    },
    selectLanguage(value) {
      this.$i18n.locale = value
      localStorage.setItem('lang', value)
      // this.$router.go(0)
    },

    // 调用store中的方法，修改state数据
    changeStorePageId: function (list) {
      this.$store.commit('changePageId', list)
      // console.log('after:this.$store.state', this.$store.state.pageId);
    },

    changeStoreRouterStack: function (routeStack, type) {
      // console.log(routeStack + '+' + type);
      // this.$store.commit("changRouterStack", routeStack, type)
    },

    // 修改store中的showApplay
    changeShowApply: function (value) {
      this.$store.commit('changeShowApplay', value);
    },

    // 获取store中state
    getStoreState: function () {
      this.pageId = this.$store.state.pageId;
      console.log('before:this.$store.state', this.$store.state.pageId);
    },

    getShowApply: function() {
      // this.showApply = this.$store.state.showAapply;
    },


    // 非菜单栏路由切换，改变activeIndex
    changeActiveIndex(href) {
      this.activeIndex = href;
    },

    // 禁止页面滚动
    stopMove() {
      let m = function (e) {
        e.preventDefault();

      };
      document.body.style.overflow = "hidden";
      // 禁止页面滚动
      document.addEventListener("touchmove", m, { passive: false });
    },

    // 允许页面滚动
    allowMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", m, { passive: true });
    },
    // 设置弹框显示
    handleRegestion(show) {
      console.log('show:', show);
      this.isShowRegestion = show;
      // this.stopMove();
      show ? this.stopMove() : this.allowMove();
    },

    showImage(src) {
      this.alertImgSrc = src;
      this.showAlertImg = true;
      this.stopMove();
    },

    handleImage(show, src) {
      if (src) {
        this.alertImgSrc = src;
      }
      this.showAlertImg = show;
      show ? this.stopMove() : this.allowMove();
    },

    // 页面切换
    handleSelect(event) {
      console.log('event:', event);
    },

    handleSelect1(param) {
      const mouseball = this.$refs._mouseAnim;
      mouseball.classList.remove("mouse_anim_hover");
      if (param != "/index") {
        this.activeIndex = param;
        this.$router.push(param);
      }
    },

    // 显示隐藏报名咨询按钮
    showApply(param) {
      this.isShowApply = param;
      var footer_endEl = document.getElementsByClassName("footer_end");
      if (param) {
        footer_endEl[0].style = `margin-bottom: 100px;`
      } else {
        footer_endEl[0].style = `margin-bottom: 0px;`
      }
    },

    moveTo(x, y) {
      return new Promise((resolve) => {
        document.getElementById("upper").style.transform = "translate(x, y)";
        document.getElementById("upper").style.transition = "transform 1s ease";
        // console.log("movex:", x);
        setTimeout(resolve(), 1000);
      });
    },

    // 鼠标移出，与mouseout区别
    mouseleave() {
      // console.log("鼠标移出");
      if (!this.showHeadButton) {
        document.getElementById("lower").style.transform = "translate(0, 0)";
        document.getElementById("lower").style.transition =
          "transform .5s ease";
      }
    },

    // 获得滚动条高度
    getScrollTop: function () {
      
    },

    resize() {
      var width =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      var fullHeight = window.screen.availHeight;
      var fullWidth = window.screen.availWidth;
      this.coverHeight = (fullHeight / fullWidth) * width;
      this.coverHeightGlobal = this.coverHeight;

      // 获取窗口的高度与宽度(不包含工具栏与滚动条):
      this.coverHeight = window.innerHeight;
    },

    // 监听浏览器返回
    goBack () {
      this.handleImage(false);
      // console.log('点击了浏览器返回按钮');
      // console.log(window.history);
      // console.log(document.URL);
      var url = document.URL.split("/");
      var urlLength = url.length;
      var href = "/" + url[urlLength - 1];
      var list;
      // console.log('url:', url);
      // console.log(url[urlLength-1])
      if (href == "/" || href == "/index") {
        list = this.menuData[0]
      } else if (href == "/courseCenter" || href == "/businessCourse" || href== "/strategicCourse" || href == "/growthCourse")  {
        list = this.menuData[1]
      } else if (href == "/dynamic") {
        list = this.menuData[2]
      } else if (href == "/contactUs") {
        list = this.menuData[3]
      }
      // console.log('list:', list);
      this.changeActiveIndex(href);
      // this.showPageIndex(list);
      this.changeStorePageId(list);
    },
    goToNet() {
      var openNew = this.$router.resolve({path: 'staffLogin'})
      window.open(openNew.href,'_blank')
    }
  },
  };
</script>

<style src="./css/common.css"></style>
<style src="./css/style.css"></style>
<style>
/* @font-face {
  font-family: "SourceHanSansSC";
  src: url("./font/SourceHanSansSC-Light.otf");
} */

@font-face {
  font-family: "Bliss2R";
  src: url("./font/Bliss2R.otf");
}

@font-face {
  font-family: "Lato";
  src: url("./font/Lato-Regular.woff");
}

@font-face {
  font-family: "Lato-Light";
  src: url("./font/Lato-Light.woff");
}

@font-face {
  font-family: "Lato-Bold";
  src: url("./font/Lato-Bold.woff");
}

.Mhei{
  font-family: "SourceHanSansSC";
}
.Lato{
  font-family: "Lato";
}
.Lato-Light{
  font-family: "Lato-Light", "Microsoft JhengHei";
}
.Lato-Bold{
  font-family: "Lato-Bold";
}
.phonemenu{
  display: none;
}
.macCarousel{
  display: none;
}
.vip-title{
  text-align: right;
  min-width: 160px;
  line-height: 32px;
  font-size: 24px;
  font-weight: 500;
  margin-right: 20px;
}
/* <=767*/
@media only screen and(max-width: 767px){
  html, body {
    font-size: 18px;
  }

  #footer .footer-links .other-links{
    margin-bottom: 10px;
    padding-right: 25px;
  }

  .other-links {
    text-align: start;
  }
}

@media screen and (max-width:768px) {
  html, body {
    font-size: 18px;
  }
  .pcmenu{
    display: none;
  }
  .macCarousel{
    display: none;
  }
  .phonemenu{
    display: block;
    text-align: right;
    line-height: 60px;
  }
  .logo img{
    height: 100%;
  }
  #header .field-lang .icon-trigger {
    cursor: pointer;
    margin-right: 0;
  }
  .col {
    /* padding-left: 15px; */
    padding-right: 0;
  }
  .vip-title{
    min-width: 0px;
    font-size: 19px;
  }
  .group-member{
    justify-content: start;
  }
}

/* >=768*/
@media only screen and (min-width: 768px) {
  .links {
    position: absolute;
    right: 0px;
  }

  .other-links {
    text-align: end;
  }
}

/* >=1300 <=1600*/
@media only screen and (min-width: 1300px) and (max-width: 1600px){
  
}

@media only screen and (max-width: 1399px) {
  h2 {
    font-size: 50px;
  }
  .macCarousel{
    display: block;
  }
  .winCarousel{
    display: none;
  }
}

* {
  margin: 0;
  padding: 0;
}

*, ::after, ::before {
  box-sizing: border-box;
}

html,
body,
#app,
.tourism-content {
  width: 100%;
  position: relative;
  background-color: #fff;
  font-size: 20px;
}

/* 设置基准字体大小 */
html {
  font-size: 62.5%;
}

h2 {
  font-size: 56px;
  font-weight: 300;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  line-height: 1.1;
  margin-bottom: 0.5em;
}
/* body {font-size:12px;font-size:1.2rem ;}  */
/* p {font-size:14px;font-size:1.4rem;} */

a:link,
a:visited,
a:hover,
a:active {
  text-decoration: none;
}

.isClick {
  cursor: pointer;
}

.v-body {
  transition: all 1s ease;
  transform: translateY(0);
}
.v-body.active {
  transform: translateY(300px);
}

.v-footer.active {
  transform: translateY(300px);
}

.my_animate_img img {
  width: 100%;
  transition: all 0s;
  transition-delay: 0.8s;
  transform: translateX(100%);
}
.animate-delay img,
.animate-delay:after {
  animation-delay: 1s;
}
.animate-delay2 img,
.animate-delay2:after {
  animation-delay: 1.2s;
}
@keyframes imgmask {
  0% {
    right: -100%;
  }
  50% {
    right: 0;
  }
  55% {
    right: 0;
  }
  100% {
    right: -100%;
  }
}
@keyframes imganmi {
  0% {
    transform: translateX(0%);
    opacity: 0;
  }
  /* 60% {transform: translateX(0%); opacity: 0; } */
  50% {
    transform: translateX(-15%);
    opacity: 0;
  }
  55% {
    transform: translateX(-15%);
    opacity: 1;
  }
  100% {
    transform: translateX(0%);
    opacity: 1;
  }
}
.mouse_anim {
  position: absolute;
  top: -20px;
  left: -20px;
  width: 10px;
  height: 10px;
  z-index: 1000;
  pointer-events: none;
}
.mouse_anim::before {
  content: "";
  display: block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0px;
  height: 0px;
  transform: translate(-50%, -50%);
  border-radius: 45px;
  transition: all 0.5s ease;
}
.mouse_anim_hover::before {
  width: 30px; height: 30px;
}

.login-box{
  padding: 8px 28px 0 28px;
}
.login-row{
  width: 316px;
  margin-bottom: 18px;
}
</style>
<style scoped>
  /deep/ .el-menu-item{
    font-size: 19px;
  }
  /deep/ .el-submenu__title{
    font-size: 19px;
  }
  /deep/ .el-dropdown-menu__item{
    font-size: 20px;
  }
  /deep/ .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{
    color: #ed6d00;
  }
  /deep/ .el-dropdown-menu__item{
    font-family: "Lato-Light";
  }
  .menuItem{
    font-size: 16px;
    font-family: 'Lato',"Microsoft JhengHei";
  }
  @media screen and (max-width: 1399px) {
    /deep/ .el-menu-item{
      font-size: 15px;
    }
    /deep/ .el-submenu__title{
      font-size: 15px;
    }
    .menuItem {
      font-size: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue